<div class="discount-popup">

    <!-- Header -->
    <div class="popup-header">
        <div class="header-icon">
            <mat-icon>local_offer</mat-icon>
        </div>
        <h2 mat-dialog-title>🎉 Exklusiver 10% Rabatt für Sie!</h2>
        <button mat-icon-button mat-dialog-close class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Content -->
    <mat-dialog-content class="popup-content">
        <!-- Prominenter Rabattcode -->
        <div class="discount-code-prominent">
            <div class="code-label">Ihr Rabattcode:</div>
            <div class="code-display-main">
                <span class="code-text-large">{{ data.code }}</span>
                <button mat-icon-button (click)="copyCode()" matTooltip="Code kopieren" class="copy-button">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <!-- Anleitung zur Einlösung -->
        <div class="redemption-instructions">
            <h3>So lösen Sie Ihren Rabatt ein:</h3>
            <div class="instruction-item">
                <mat-icon>phone</mat-icon>
                <span><strong>Telefon:</strong> Nennen Sie einfach den Code <strong>{{ data.code }}</strong> bei Ihrer Bestellung</span>
            </div>
            <div class="instruction-item">
                <mat-icon>email</mat-icon>
                <span><strong>E-Mail:</strong> Geben Sie den Code <strong>{{ data.code }}</strong> in Ihrer Nachricht an</span>
            </div>
            <div class="instruction-item">
                <mat-icon>chat</mat-icon>
                <span><strong>WhatsApp:</strong> Schicken Sie uns den Code <strong>{{ data.code }}</strong> per WhatsApp</span>
            </div>
            <div class="instruction-item">
                <mat-icon>store</mat-icon>
                <span><strong>Im Laden:</strong> Zeigen Sie den Code <strong>{{ data.code }}</strong> direkt vor Ort</span>
            </div>
        </div>

        <div class="discount-info">
            <div class="discount-value">
                <span class="discount-text">{{ data.discountText }}</span>
            </div>
            <div class="validity-info">
                ⏰ Gültig bis zum 18.08.2025
            </div>
        </div>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions class="popup-actions">
        <button mat-raised-button color="primary" mat-dialog-close class="close-main-button">
            <mat-icon>check</mat-icon>
            Verstanden
        </button>
    </mat-dialog-actions>
</div>